var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { clsx } from 'clsx';
function Section(_a) {
    var children = _a.children, _b = _a.style, style = _b === void 0 ? {} : _b, _c = _a.className, className = _c === void 0 ? '' : _c, id = _a.id, _d = _a.paddingStyle, paddingStyle = _d === void 0 ? 'wide' : _d, _e = _a.gapSize, gapSize = _e === void 0 ? 'none' : _e;
    var mobilePaddingClassName = '';
    var desktopPaddingClassName = '';
    switch (paddingStyle) {
        case 'narrow':
            mobilePaddingClassName = 'pt-m-page-top-m pb-sm-gutter px-2xs-m';
            desktopPaddingClassName = 'md:py-3xl-page-bottom-web md:px-2xl-gutter';
            break;
        case 'wide':
            mobilePaddingClassName = 'py-lg-gutter px-2xs-m';
            desktopPaddingClassName = 'md:py-3xl-page-bottom-web md:px-3xl-gutter';
            break;
        default:
    }
    var padding = clsx(mobilePaddingClassName, desktopPaddingClassName);
    var gap;
    switch (gapSize) {
        case '2xs':
            gap = 'gap-2xs-m';
            break;
        case 'xs':
            gap = 'gap-xs-m';
            break;
        case 'sm':
            gap = 'gap-sm-m';
            break;
        case 'md':
            gap = 'gap-md-m';
            break;
        case 'lg':
            gap = 'gap-lg-m';
            break;
        case 'xl':
            gap = 'gap-xl-m';
            break;
        case '2xl':
            gap = 'gap-2xl-m';
            break;
        case '3xl':
            gap = 'gap-3xl-m';
            break;
        case '4xl':
            gap = 'gap-4xl-m';
            break;
        default:
            gap = '';
    }
    var flex = 'flex flex-col md:flex-row basis-[100%] justify-start md:justify-between md:items-center w-full';
    var size = 'w-full max-w-[100vw] md:max-w-[calc(100vw - 24px)]';
    return (_jsx("section", __assign({ style: __assign({}, style), id: id, className: clsx(padding, className) }, { children: _jsx("div", __assign({ className: clsx('overflow-hidden', flex, size, gap) }, { children: children })) })));
}
export default Section;
